import queueClosureDispatcher from '../action';
import { TYPE_MODAL } from '../constants';
import {
  ArrowDown,
  CloseIcon,
  NoDataQueueClosureIcon,
  RadioActiveIcon,
  RadioInactiveIcon,
} from '@/assets/svg';
import AsyncAutoComplete from '@/components/AsyncAutoComplete';
import { StatusComponent } from '@/module/all-screenings/component/StatusComponent';
import clinicApptDispatcher from '@/module/clinic-appointment/action';
import { COLUMN_CLINIC_APPOINTMENT } from '@/module/clinic-appointment/constants';
import TableCellFilted from '@/module/common/componentUI/TableCellFilted';
import { CustomAutocomplete } from '@/module/company/component/CreateAndEditCompany/styled';
import { getFullTimeInDay } from '@/module/setup/utils';
import {
  FORMAT_DATE_TIME,
  MIN_TIME_PICK,
  MAX_TIME_PICK,
} from '@/module/telecounsel-appointment-configuration/constants';
import CustomDate from '@/new-components/CustomDate';
import CustomLoadingButton from '@/new-components/CustomLoadingButton';
import ModalConfirmation from '@/new-components/CustomModal/ModalConfirmation';
import CustomTable from '@/new-components/CustomTable';
import CustomTooltip from '@/new-components/CustomTooltip';
import {
  Box,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Typography,
  makeStyles,
  withStyles,
  TextField,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { Divider } from 'antd';
import { debounce, isBoolean, isEmpty } from 'lodash';
import moment from 'moment';
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';

const CustomMainLabel = withStyles((theme) => ({
  root: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 16,
    color: '#191919',
  },
}))(Typography);

const CustomInputLabel = withStyles((theme) => ({
  root: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 4,
    color: '#666666',
  },
}))(Typography);

const CustomTextField = withStyles({
  root: {
    fontSize: 20,
    width: '100%',

    '& .MuiOutlinedInput-root': {
      height: 48,
      borderRadius: 8,
    },
    '& .MuiOutlinedInput-input': {
      marginRight: (props) => (props.hasClear ? 0 : 30),
      padding: '8px 5px',
      fontSize: 16,
    },

    '& .Mui-disabled': {
      '&.MuiOutlinedInput-root': {
        backgroundColor: '#f6f6f6',
      },
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
    '& .MuiInputBase-multiline': {
      height: 'auto',
      paddingLeft: 0,

      '& .MuiOutlinedInput-input': {
        marginRight: 8,
      },
    },
  },
})(TextField);

const CustomPaper = withStyles((theme) => ({
  root: {
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent',
    },

    '& .MuiAutocomplete-option': {
      padding: 8,
      borderRadius: 8,
      margin: '2px 8px',
      '&:first-child': {
        marginTop: 8,
      },
      '&:last-child': {
        marginBottom: 8,
      },
      '&.MuiAutocomplete-option[aria-selected="true"]': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
}))(Paper);

const titleStyles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    fontSize: 18,
    color: '#333',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: 14,
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    height: 'calc(100vh - 140px)',
    overflow: 'auto',
  },
  stepsControlWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1),
  },
}));

const CustomDrawerTitle = withStyles(titleStyles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <Box className={classes.root} {...other} borderBottom={'1px solid #E0E0E0'}>
      <Typography variant="h6" className={classes.title}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </Box>
  );
});

const ModalCreateEditClosure = ({
  loading,
  onClose,
  onSubmit,
  typeModal,
  selectedItem,
  setShowCancelModal,
}) => {
  const { listAffectedAppt: data, pagingAffectedAppt: paging } = useSelector(
    (state) => state.queueClosure
  );
  const classes = useStyles();

  const [filterOption, setFilterOption] = useState({});
  const [sortOption, setSortOption] = useState({});
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [formValue, setFormValue] = useState({
    reason: null,
    startDate: null,
    endDate: null,
    startTime: MIN_TIME_PICK,
    endTime: moment().set({ hour: 23, minute: 45 }),
    locationId: '',
    location: {},
  });

  let timeSlotsStartDefault = getFullTimeInDay(0, 24, 15).filter((obj) => {
    const slotTime = moment(obj.value, 'h:mm A');
    if (moment(formValue.startDate).isSame(moment(), 'day')) {
      return slotTime.isAfter(moment());
    }
    return true;
  });
  // timeSlotsStartDefault.push({
  //   key: '11:59 PM',
  //   value: '11:59 PM',
  // });
  let timeSlotsEndDefault = getFullTimeInDay(0, 24, 15).filter((obj) =>
    moment(formValue?.startTime)
      .set({
        hour: moment(obj.value, 'h:mm A').hour(),
        minute: moment(obj.value, 'h:mm A').minute(),
      })
      .isAfter(formValue?.startTime)
  );
  // timeSlotsEndDefault.push({
  //   key: '11:59 PM',
  //   value: '11:59 PM',
  // });

  const handleChangeForm = (key) => (e, newValue) => {
    let value = '';
    switch (key) {
      case 'startDate':
        value = moment(e).startOf('date').format();
        if (moment(e).isSame(moment(), 'day')) {
          setFormValue({
            ...formValue,
            [key]: value,
            startTime: null,
            endTime: null,
          });
        } else
          setFormValue({
            ...formValue,
            [key]: value,
          });

        return;
      case 'endDate':
        value = moment(e).endOf('date').format();
        break;
      case 'startTime':
        value = moment(newValue.value, 'h:mm A');
        break;
      case 'endTime':
        if (
          moment(newValue.value, 'h:mm A').format(FORMAT_DATE_TIME) ===
          moment(MIN_TIME_PICK).format(FORMAT_DATE_TIME)
        )
          value = MAX_TIME_PICK;
        value = moment(newValue.value, 'h:mm A');
        break;
      case 'reason':
        value = e.target.value;
        break;

      default:
        value = newValue;
        break;
    }

    setFormValue({ ...formValue, [key]: value });
  };

  const handleSubmit = () => {
    // Start date
    const startHours = moment(formValue.startTime, 'hh:mm A').get('hour');
    const startMinutes = moment(formValue.startTime, 'hh:mm A').get('minute');

    const newStartDate = moment(formValue.startDate).set({
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    // End date

    const endHours = moment(formValue.endTime, 'hh:mm A').get('hour');
    const endMinutes = moment(formValue.endTime, 'hh:mm A').get('minute');

    const newEndDate = moment(formValue.endDate).set({
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    const newParams = {
      reason: formValue.reason,
      locationId: formValue.location?.id,
      startDate: newStartDate.format('YYYY-MM-DDT00:00:00.000') + 'Z',
      endDate: newEndDate.format('YYYY-MM-DDT00:00:00.000') + 'Z',
      startTime: moment(formValue.startTime, 'hh:mm A').format('HH:mm:ss'),
      endTime: moment(formValue.endTime, 'hh:mm A').format('HH:mm:ss'),
    };

    onSubmit(typeModal, newParams);
  };

  const fetchData = async (
    pagingData = paging,
    sortOptionData = sortOption,
    filterOptionData = filterOption
  ) => {
    queueClosureDispatcher.getAffectedAppt(
      undefined,
      pagingData,
      sortOptionData,
      filterOptionData
    );
  };

  const debounceLoadData = useCallback(
    debounce((paging, sortOption, filterOption) => {
      fetchData(
        {
          pageIndex: 0,
          pageSize: paging.pageSize,
        },
        sortOption,
        filterOption
      );
    }, 500),
    []
  );

  const isShowClinicTable = useMemo(() => {
    const filterKeys = [
      'location',
      'startDate',
      'endDate',
      'startTime',
      'endTime',
    ];
    return filterKeys.every((key) =>
      !isBoolean(formValue[key]) ? formValue[key] : !isEmpty(formValue[key])
    );
  }, [formValue]);

  const isEmptyParams = useMemo(() => {
    const filterKeys = [
      'location',
      'startDate',
      'endDate',
      'startTime',
      'endTime',
    ];
    return filterKeys.some((key) =>
      isBoolean(formValue[key]) ? !formValue[key] : isEmpty(formValue[key])
    );
  }, [formValue]);

  useEffect(() => {
    if (isShowClinicTable && !isEmpty(formValue.location))
      debounceLoadData(paging, sortOption, filterOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortOption, filterOption, isShowClinicTable]);

  useEffect(() => {
    if (!selectedItem) return;
    const newFormValue = { ...selectedItem } || {};

    newFormValue.location = {
      id: newFormValue.locationId,
      name: newFormValue.locationName,
    };

    newFormValue.startTime = moment(newFormValue.startTime, 'HH:mm:ss');
    newFormValue.endTime = moment(newFormValue.endTime, 'HH:mm:ss');

    setFormValue(newFormValue);
  }, [selectedItem]);

  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {COLUMN_CLINIC_APPOINTMENT.map((item) =>
          item.stateValue === 'action' ? null : item.sortBy ? (
            <TableCellFilted
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
              sortBy="Date"
              sortOption={sortOption}
              onSortChange={() => {
                let newSortOption = {
                  sortBy: 'BookedApptDate',
                  orderBy: sortOption.orderBy !== 'Asc' ? 'Asc' : 'Desc',
                };
                setSortOption(newSortOption);
              }}
              style={{
                minWidth: item.minWidth || 'unset',
                width: item.width || 'unset',
              }}
              isHidden={false}
            />
          ) : (
            <TableCellFilted
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
              style={{
                minWidth: item.minWidth || 'unset',
                width: item.width || 'unset',
              }}
              isHidden={false}
            />
          )
        )}
      </TableRow>
    </TableHead>
  );
  const renderDateTime = (date) => {
    let startDateFormat, startTimeFormat;
    if (!date) return null;

    startDateFormat = moment(date).format('DD/MM/YYYY');
    startTimeFormat = moment(date).format('LT');
    return `${startDateFormat} ${startTimeFormat}`;
  };

  const renderTableBody = (row) => {
    return (
      <>
        <TableCell>
          <CustomTooltip content={row.patientName} />
        </TableCell>
        <TableCell>
          <CustomTooltip content={row.patientNric} />
        </TableCell>
        <TableCell>
          <CustomTooltip content={row.purposeName} />
        </TableCell>
        <TableCell>
          <CustomTooltip
            content={
              !isEmpty(row?.subPurposes?.filter((it) => it && it !== null))
                ? row.subPurposes.join(', ')
                : '—'
            }
          />
        </TableCell>
        <TableCell>{renderDateTime(row.date)}</TableCell>
        <TableCell>
          <CustomTooltip content={row.locationName} />
        </TableCell>
        <TableCell>
          <StatusComponent
            status={
              row.paxScreenStatus ||
              row.clinicAppointmentStatus ||
              row.queueRequestStatus
            }
          />
        </TableCell>
      </>
    );
  };

  useEffect(() => {
    if (isShowClinicTable && !isEmpty(formValue.location)) {
      // Start date
      const startHours = moment(formValue.startTime, 'hh:mm A').get('hour');
      const startMinutes = moment(formValue.startTime, 'hh:mm A').get('minute');

      const newStartDate = moment(formValue.startDate).set({
        hours: startHours,
        minutes: startMinutes,
        seconds: 0,
      });

      // End date

      const endHours = moment(formValue.endTime, 'hh:mm A').get('hour');
      const endMinutes = moment(formValue.endTime, 'hh:mm A').get('minute');

      const newEndDate = moment(formValue.endDate).set({
        hours: endHours,
        minutes: endMinutes,
        seconds: 0,
      });

      setFilterOption({
        ...filterOption,
        locationId: formValue.location?.id,
        fromDate: newStartDate.format('YYYY-MM-DDT00:00:00.000') + 'Z',
        toDate: newEndDate.format('YYYY-MM-DDT00:00:00.000') + 'Z',
        startTime: moment(formValue.startTime, 'hh:mm A').format('HH:mm:ss'),
        endTime: moment(formValue.endTime, 'hh:mm A').format('HH:mm:ss'),
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValue, isShowClinicTable]);

  return (
    <Paper square elevation={0}>
      <CustomDrawerTitle onClose={onClose}>
        {typeModal === TYPE_MODAL.Edit
          ? 'Edit Queue Closure'
          : typeModal === TYPE_MODAL.View
          ? 'View Queue Closure'
          : 'Queue Closure Request'}
      </CustomDrawerTitle>
      <main className={classes.mainWrapper}>
        <Box p={3}>
          <Grid container>
            {typeModal === TYPE_MODAL.Edit && (
              <Grid item xs={12} style={{ marginBottom: 16 }}>
                <Box
                  display="flex"
                  justifyContent={'space-between'}
                  alignItems={'center'}
                >
                  <CustomMainLabel style={{ marginBottom: 0 }}>
                    {selectedItem?.queueClosureShortId}
                  </CustomMainLabel>
                  <Box alignSelf={'flex-end'}>
                    <div style={{ textAlign: 'right' }}>
                      Requested by:{' '}
                      <Typography component={'strong'} color="primary">
                        {selectedItem?.requestedBy}
                      </Typography>{' '}
                      on {renderDateTime(selectedItem.creationTime)}
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      Last updated by:{' '}
                      <Typography component={'strong'} color="primary">
                        {selectedItem?.lastUpdatedBy}
                      </Typography>{' '}
                      on {renderDateTime(selectedItem.lastModificationTime)}
                    </div>
                  </Box>
                </Box>
              </Grid>
            )}
            <Grid item xs={12}>
              <CustomMainLabel>Closure reason</CustomMainLabel>
              <RadioGroup
                row
                value={formValue.reason}
                onChange={handleChangeForm('reason')}
              >
                <FormControlLabel
                  value="NoDoctor"
                  control={
                    <Radio
                      style={{ marginLeft: 3 }}
                      icon={<RadioInactiveIcon />}
                      checkedIcon={<RadioActiveIcon />}
                      color="primary"
                    />
                  }
                  disabled={typeModal === TYPE_MODAL.View}
                  label="No doctor on duty"
                />
                <FormControlLabel
                  value="Overwhelmed"
                  control={
                    <Radio
                      style={{ marginLeft: 3 }}
                      icon={<RadioInactiveIcon />}
                      checkedIcon={<RadioActiveIcon />}
                      color="primary"
                    />
                  }
                  disabled={typeModal === TYPE_MODAL.View}
                  label="Queue already overwhelmed"
                />
              </RadioGroup>
            </Grid>
            <Grid item xs={12}>
              <Divider light />
            </Grid>
            <Grid item xs={12}>
              <CustomMainLabel>Closure details</CustomMainLabel>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CustomInputLabel>Location</CustomInputLabel>
                <AsyncAutoComplete
                  label="Locations"
                  endpoint="locations/filter"
                  method="post"
                  isLocation
                  defaultFilter={{
                    sortByName: true,
                    hasPlatoName: true,
                    statuses: ['Active'],
                  }}
                  value={formValue.location}
                  setValue={(newValue) => {
                    setFormValue({
                      ...formValue,
                      appointmentTime: '',
                      location: newValue,
                    });
                  }}
                  getOptionLabel={(option) => option.name || ''}
                  nameKey="name"
                  renderInput={(params) => (
                    <CustomTextField
                      variant="outlined"
                      {...params}
                      placeholder="Select location"
                    />
                  )}
                  disableClearable
                  PaperComponent={({ children, ...other }) => (
                    <CustomPaper {...other}>{children}</CustomPaper>
                  )}
                  disabled={
                    isEmpty(formValue.reason) || typeModal === TYPE_MODAL.View
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <CustomInputLabel>Start date</CustomInputLabel>
                <CustomDate
                  selectedDate={
                    formValue.startDate ? moment(formValue.startDate) : null
                  }
                  minDate={moment()}
                  maxDate={formValue.endDate}
                  isFullWidth
                  placeholder="DD/MM/YYYY"
                  clearable={false}
                  onChange={handleChangeForm('startDate')}
                  style={{ height: 48, fontSize: 16 }}
                  disabled={
                    isEmpty(formValue.reason) || typeModal === TYPE_MODAL.View
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <CustomInputLabel>End date</CustomInputLabel>
                <CustomDate
                  selectedDate={
                    formValue.endDate ? moment(formValue.endDate) : null
                  }
                  minDate={formValue.startDate || moment()}
                  isFullWidth
                  placeholder="DD/MM/YYYY"
                  clearable={false}
                  onChange={handleChangeForm('endDate')}
                  style={{ height: 48, fontSize: 16 }}
                  disabled={
                    isEmpty(formValue.reason) || typeModal === TYPE_MODAL.View
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <CustomInputLabel>From time slot</CustomInputLabel>
                <CustomAutocomplete
                  getOptionSelected={(option, value) => option === value}
                  getOptionLabel={(option) => option.value || ''}
                  options={timeSlotsStartDefault || []}
                  value={
                    timeSlotsStartDefault?.find(
                      (it) =>
                        it?.value ===
                        moment(formValue?.startTime).format('h:mm A')
                    ) || ''
                  }
                  onChange={handleChangeForm('startTime')}
                  popupIcon={<ArrowDown />}
                  renderInput={(params) => (
                    <CustomTextField
                      variant="outlined"
                      placeholder="Select time slot"
                      {...params}
                    />
                  )}
                  disableClearable
                  PaperComponent={({ children, ...other }) => (
                    <CustomPaper {...other}>{children}</CustomPaper>
                  )}
                  disabled={
                    isEmpty(formValue.reason) || typeModal === TYPE_MODAL.View
                  }
                />
              </Grid>

              <Grid item xs={6}>
                <CustomInputLabel>To time slot</CustomInputLabel>
                <CustomAutocomplete
                  getOptionSelected={(option, value) => option === value}
                  getOptionLabel={(option) => option.value || ''}
                  options={timeSlotsEndDefault || []}
                  value={
                    timeSlotsEndDefault?.find(
                      (it) =>
                        it?.value ===
                        moment(formValue?.endTime).format('h:mm A')
                    ) || ''
                  }
                  onChange={handleChangeForm('endTime')}
                  popupIcon={<ArrowDown />}
                  renderInput={(params) => (
                    <CustomTextField
                      variant="outlined"
                      placeholder="Select time slot"
                      {...params}
                    />
                  )}
                  disableClearable
                  PaperComponent={({ children, ...other }) => (
                    <CustomPaper {...other}>{children}</CustomPaper>
                  )}
                  disabled={
                    isEmpty(formValue.reason) || typeModal === TYPE_MODAL.View
                  }
                />
              </Grid>
            </Grid>

            {isShowClinicTable && !isEmpty(formValue.location) && (
              <Grid item xs={12} style={{ marginTop: 24 }}>
                <CustomMainLabel>
                  List of appointments ({data?.length})
                </CustomMainLabel>
                <CustomTable
                  data={data}
                  paging={paging}
                  header={TableHeader}
                  renderRow={(row, i) => renderTableBody(row)}
                  noDataHelperText="No appointment available"
                  noDataHelperSubText=""
                  Icon={NoDataQueueClosureIcon}
                  totalCols={COLUMN_CLINIC_APPOINTMENT.length}
                  fetchData={fetchData}
                />
              </Grid>
            )}
          </Grid>
        </Box>
      </main>

      {typeModal === TYPE_MODAL.View ? (
        <Box
          display="flex"
          justifyContent="flex-end"
          py={1.75}
          px={1.25}
          gridGap={16}
          borderTop={'1px solid #E0E0E0'}
        >
          <CustomLoadingButton
            variant="contained"
            color="primary"
            onClick={onClose}
          >
            Close
          </CustomLoadingButton>
        </Box>
      ) : (
        <Box
          display="flex"
          justifyContent="flex-end"
          py={1.75}
          px={1.25}
          gridGap={16}
          borderTop={'1px solid #E0E0E0'}
        >
          <CustomLoadingButton
            variant="outlined"
            color="primary"
            onClick={onClose}
          >
            Cancel
          </CustomLoadingButton>
          {typeModal === TYPE_MODAL.Edit && (
            <CustomLoadingButton
              variant="contained"
              color="primary"
              loading={loading}
              onClick={() => setShowCancelModal(true)}
              style={{ width: 'fit-content' }}
            >
              Stop Queue Closure
            </CustomLoadingButton>
          )}
          <CustomLoadingButton
            variant="contained"
            color="primary"
            loading={loading}
            disabled={isEmptyParams || loading}
            onClick={() => setShowModalConfirm(true)}
          >
            {typeModal === TYPE_MODAL.Create ? 'Save' : 'Update'}
          </CustomLoadingButton>
        </Box>
      )}

      {showModalConfirm && (
        <ModalConfirmation
          open={showModalConfirm}
          onClick={handleSubmit}
          onClose={() => setShowModalConfirm(false)}
          mainContent={
            typeModal === TYPE_MODAL.Create
              ? 'Close queue'
              : 'Update queue closure'
          }
          subContent={'Has management been informed?'}
          cancelLabel="No"
          confirmLabel="Yes"
        />
      )}
    </Paper>
  );
};

export default ModalCreateEditClosure;
